$(document).ready(function() {


    //logo loader

    var sizes = ["s", "m", "l"],
        iconLWidth = 256,
        container = document.getElementById("integrationList"),
        icons = document.querySelectorAll("#integrationList img"),
        resizeTimer,
        w,
        h;
    // debounce the re-init so it doesn't totally freak out while draging
    window.addEventListener("resize", resizeDebounce);
    window.addEventListener("load", resizeDebounce);

    function resizeDebounce() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(init, 250);
    }

    function init() {
        w = container.offsetWidth;
        h = container.offsetHeight;
        icons.forEach(function(icon, i) {
            var size = sizes[Math.ceil(Math.random() * 3) - 1];
            TweenMax.set(icon, {
                attr: { class: size },
                y: R(50, h - 200),
                x: R(w, w + 50)
            });
            animate(icon, i);
        });
    }
    // animate x and y values at different rates
    function animate(element, i) {
        TweenMax.to(element, R(110, 120), {
            x: -1500,
            ease: Linear.easeNone,
            repeat: -1,
            delay: (-115 / icons.length) * i
        });
        TweenMax.to(element, R(6, 16), {
            y: "+=50",
            repeat: -1,
            yoyo: true,
            ease: Sine.easeInOut,
            delay: R(-16, -6)
        });
    }

    function R(min, max) {
        return min + Math.random() * (max - min);
    }



    let heightEle = $(".js-v-slider .swiper-slide").innerHeight()

    // $(".js-v-slider").css("height", heightEle)
    // $(".js-slider-wrppr").css("height", heightEle)
    $(".js-slider-total").text($(".js-v-slider .swiper-slide").length)
    var swiperJob = new Swiper('.js-v-slider', {
        direction: 'vertical',
        slidesPerView: 1,
        mousewheel: true,
        // autoHeight: true,
        pagination: {
            el: '.js-swiper-pagination',
            clickable: true,
        },
    });
    var swiperImg = new Swiper('.js-img-slider', {

        slidesPerView: 1,


    });

    swiperJob.controller.control = swiperImg;
    swiperImg.controller.control = swiperJob;


    swiperJob.on('slideChange', function(current) {
        $(".js-current-slide").text(swiperJob.realIndex + 1)
    });


    //testimonial slider



    var swiperImg = new Swiper('.js-testimonial-slider', {
        autoplay: true,
        loop: true,
        slidesPerView: 1,
        speed: 1500,
        navigation: {
            nextEl: ".js-swiper-button-next",
            prevEl: ".js-swiper-button-prev",
        },
        pagination: {
            el: '.custom-pagination-swiper',
            type: 'bullets',
            clickable: true
        },

    });

    var swiperLogo = new Swiper('.js-logo-slider', {
        spaceBetweet: 30,
        slidesPerView: 5,
        Infinity: true,
        loop: true,
        autoplay: true,
        speed: 1500,
        // autoHeight: true,
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 30
            }
        }

    });


    //mobile slider


    // breakpoint where swiper will be destroyed
    // and switches to a dual-column layout
    const breakpoint = window.matchMedia('(min-width:768px)');

    // keep track of swiper instances to destroy later
    let mySwiper;


    const breakpointChecker = function() {

        // if larger viewport and multi-row layout needed
        if (breakpoint.matches === true) {

            // clean up old instances and inline styles when available
            if (mySwiper !== undefined) mySwiper.destroy(true, true);

            // or/and do nothing
            return;

            // else if a small viewport and single column layout needed
        } else if (breakpoint.matches === false) {

            // fire small viewport version of swiper
            return enableSwiper();

        }

    };


    const enableSwiper = function() {

        mySwiper = new Swiper('.js-mobile-slider', {

            loop: true,
            slidesPerView: 1.3,
            pagination: {
                el: ".js-swiper-pagination",
                clickable: true
            },
            paginationClickable: true,
            calculateHeight: true,
            breakpoints: {

                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 1.2,
                    spaceBetween: 8,
                },


            },
        });

    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
})